import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
import messages from './lang'

export default new VueI18n({
    // locale:  window.localStorage.getItem('lang'),
    // messages
    locale: getLanguage(), // 语言标识
    messages: messages // 上面自己定义的语言包
})

export function getLanguage() {
    const chooseLanguage = window.localStorage.getItem('lang')
    if (chooseLanguage) return chooseLanguage
    const language = (navigator.language || navigator.browserLanguage).toLowerCase()
    const locales = Object.keys(messages)
    for (const locale of locales) {
        if (language.indexOf(locale) > -1) {
            return locale
        }
    }
    return 'cn'
};

// 3.实例化一个i18n对象
// const i18n = new VueI18n({
//     locale: getLanguage(), // 语言标识
//     messages: messages // 上面自己定义的语言包
// })
// Vue.use(VueI18n);